import { graphql } from "gql";

const ADMIN_CREATE_USER_ATTRIBUTE_CATEGORY_MUTATION = graphql(`
  mutation AdminCreateUserAttributeCategory(
    $input: AdminCreateUserAttributeCategoryInput!
  ) {
    adminCreateUserAttributeCategory(input: $input) {
      ...UserAttributeCategory
    }
  }
`);

export default ADMIN_CREATE_USER_ATTRIBUTE_CATEGORY_MUTATION;
